export const PaymentMethod = {
    fromStripe: (paymentMethod) => {
        return {
            stripe_id: paymentMethod.id,
            month: paymentMethod.card.exp_month,
            year: paymentMethod.card.exp_year,
            brand: paymentMethod.card.brand,
            last_numbers: paymentMethod.card.last4
        }
    }
}